// import GET from "./GET";
// import validEmail from "./validEmail";
// const googleUserId = GET("guid");

// export const setPhone = (phone, userId) => {
// 	if (!phone) {
// 		return;
// 	}
// 	const uid =
// 		GET("email") && validEmail(GET("email"))
// 			? GET("email")?.toLowerCase() || GET("email")
// 			: userId;
// 	window.analytics.identify(uid, { phone });
// };

// export const initInstance = (userId) => {
// 	if (GET("email") && validEmail(GET("email"))) {
// 		const identityMeta = {
// 			coop_user_id: userId,
// 		};
// 		if (GET("phone")) {
// 			identityMeta.phone = GET("phone");
// 		}

// 		console.log("[ coop ] google:", googleUserId);
// 		if (googleUserId) {
// 			identityMeta.phone = GET("phone");
// 		}

// 		window.analytics.identify(
// 			GET("email")?.toLowerCase() || GET("email"),
// 			identityMeta
// 		);
// 	} else {
// 		window.analytics.identify(userId, {});
// 	}
// };
import GET from "./GET";
import store from "./store";
import validEmail from "./validEmail";

export const setPhone = (phone, userId) => {
	if (!phone) {
		return;
	}
	const uid =
		GET("email") && validEmail(GET("email"))
			? GET("email")?.toLowerCase() || GET("email")
			: userId;
	window.analytics.identify(uid, { phone });
};

export const initInstance = (userId) => {
	const identityMeta = {
		coop_user_id: userId,
		email: store.backedGET("email"),
		phone_number: store.backedGET("phone"),
		shipping_address_id: GET("shippingId"),
		billing_address_id: GET("billingId"),
		google_user_id: GET("guid"),
		customer_id: GET("customerId"),
		phone: store.backedGET("phone"),
	};

	window.analytics.identify(userId, identityMeta);
};

// import GET from "./GET";
// import validEmail from "./validEmail";
// const googleUserId = GET("guid");

// export const setPhone = (phone, userId) => {
// 	if (!phone) {
// 		return;
// 	}
// 	const uid =
// 		GET("email") && validEmail(GET("email"))
// 			? GET("email")?.toLowerCase() || GET("email")
// 			: userId;
// 	window.analytics.identify(uid, { phone });
// };

// export const initInstance = (userId) => {
// 	if (GET("email") && validEmail(GET("email"))) {
// 		const identityMeta = {
// 			coop_user_id: userId,
// 		};
// 		if (GET("phone")) {
// 			identityMeta.phone = GET("phone");
// 		}

// 		console.log("[ coop ] google:", googleUserId);
// 		if (googleUserId) {
// 			identityMeta.phone = GET("phone");
// 		}

// import GET from "./GET";
// import validEmail from "./validEmail";

// export const setPhone = (phone, userId) => {
// 	if (!phone) {
// 		return;
// 	}
// 	const uid =
// 		GET("email") && validEmail(GET("email"))
// 			? GET("email")?.toLowerCase() || GET("email")
// 			: userId;
// 	window.analytics.identify(uid, { phone });
// };

// export const initInstance = (userId) => {
// 	if (GET("email") && validEmail(GET("email"))) {
// 		const identityMeta = {
// 			coop_user_id: userId,
// 		};
// 		if (GET("phone")) {
// 			identityMeta.phone = GET("phone");
// 		}

// 		window.analytics.identify(
// 			GET("email")?.toLowerCase() || GET("email"),
// 			identityMeta
// 		);
// 	} else {
// 		window.analytics.identify(userId, {});
// 	}
// };

// import GET from "./GET";
// import validEmail from "./validEmail";

// export const setPhone = (phone, userId) => {
// 	if (!phone) {
// 		return;
// 	}
// 	const uid =
// 		GET("email") && validEmail(GET("email"))
// 			? GET("email")?.toLowerCase() || GET("email")
// 			: userId;
// 	window.analytics.identify(uid, { phone });
// };

// export const initInstance = (userId) => {
// 	if (GET("email") && validEmail(GET("email"))) {
// 		const identityMeta = {
// 			coop_user_id: userId,
// 		};
// 		if (GET("phone")) {
// 			identityMeta.phone = GET("phone");
// 		}

// 		window.analytics.identify(
// 			GET("email")?.toLowerCase() || GET("email"),
// 			identityMeta
// 		);
// 	} else {
// 		window.analytics.identify(userId, {});
// 	}
// };
